import Swal from "sweetalert2";

/**
 * Confirm before discarding a dirty create/edit form.
 * Returns true if the caller should proceed with closing.
 *
 * z-index must sit above Bootstrap / nested modals, otherwise the prompt
 * appears behind the form and users cannot click Keep editing / Exit.
 */
export async function confirmDiscardIfDirty(isDirty) {
  if (!isDirty) return true;

  const result = await Swal.fire({
    icon: "warning",
    title: "Unsaved changes",
    text: "You have not saved your progress. Exit anyway?",
    showCancelButton: true,
    confirmButtonText: "Exit anyway",
    cancelButtonText: "Keep editing",
    confirmButtonColor: "#d33",
    reverseButtons: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    heightAuto: false,
    customClass: {
      container: "swal-over-bootstrap-modal",
    },
    didOpen: () => {
      const c = document.querySelector(".swal-over-bootstrap-modal");
      if (c) c.style.zIndex = "40000";
    },
  });

  return !!result.isConfirmed;
}
